import styled from 'styled-components';

import Card from 'components/UI/Card';

const CardSkeleton = ({ children, ...rest }) => <Card {...rest}>{children}</Card>;

const StyledCardSkeleton = styled(CardSkeleton)`
    min-height: 500px;

    &:after {
        content: '';
        position: absolute;
        width: 60px;
        height: 60px;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        border-radius: 50%;
        display: inline-block;
        border-top: 4px solid var(--brand);
        border-left: 4px solid var(--brand);
        border-right: 4px solid transparent;
        box-sizing: border-box;
        animation: button-loading-spinner 1s linear infinite;
    }

    @keyframes button-loading-spinner {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`;

export default StyledCardSkeleton;
